import React, { useEffect, useState } from "react";

const giorniSettimana = [
  "domenica", "lunedì", "martedì", "mercoledì", "giovedì", "venerdì", "sabato"
];

function formatDataAAAAMMGG(date) {
  return date.toISOString().split("T")[0];
}

function formatDataGGMM(date) {
  return date.toLocaleDateString("it-IT", {
    day: "2-digit",
    month: "2-digit"
  });
}

const TendinaGiorni = ({ giornoSelezionato, callback }) => {
  const [opzioni, setOpzioni] = useState([]);

  useEffect(() => {
    const oggi = new Date();
    const nuoveOpzioni = [];

    for (let i = 0; i < 14; i++) {
      const data = new Date();
      data.setDate(oggi.getDate() + i);

      const label =
        i === 0
          ? `oggi ${formatDataGGMM(data)}`
          : i === 1
          ? `domani ${formatDataGGMM(data)}`
          : `${giorniSettimana[data.getDay()]} ${formatDataGGMM(data)}`;

      nuoveOpzioni.push({
        label,
        value: formatDataAAAAMMGG(data),
      });
    }

    setOpzioni(nuoveOpzioni);
  }, []);

  const handleChange = (e) => {
    const valore = e.target.value;
    callback(valore); // valore in formato AAAA-MM-GG
  };

  return (
    <select onChange={handleChange} value={giornoSelezionato}>
      {opzioni.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
};

export default TendinaGiorni;
